module.exports = __webpack_public_path__ + "static/images/circled-check-mark.2fAnjpi.svg";